import React from "react"
import { useTranslation } from 'react-i18next'
import { ReactComponent as PostIcon } from '../../icon/post.svg'
import { PropsWithTheme } from "../../library/Theme"
import IconButton from "./IconButton"

interface PostButtonProps {
  onPress: () => void
}

export default function PostButton({ theme, onPress }: PropsWithTheme<PostButtonProps> ) {
  const { t } = useTranslation()
  
  return (
    <IconButton theme={theme} text={t("capture.post")} onPress={onPress}>
      <PostIcon style={theme.svgWithStrokeStyle} />
    </IconButton>
  )
}